import React from "react";
import { Autocomplete, TextField } from '@mui/material'
import PropTypes from "prop-types";

export default function InputFieldSelectSimple(props) {
    // PROPS
    const { disabled, id, options, label, variant, sm, md, value, onChange, renderOption, getOptionLabel, open, onOpen, onClose, loading, style } = props

    return (
        <>
            {/** <Grid item xs={12} sm={sm === null ? 12 : sm} md={md}>*/}

            <Autocomplete
                fullWidth
                //className={classes.root}
                id={id}
                open={open}
                onOpen={onOpen}
                onClose={onClose}
                options={options}
                getOptionLabel={getOptionLabel}
                value={value}
                onChange={onChange}
                renderOption={renderOption}
                style={style}
                isOptionEqualToValue={(option, value) => option === value}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={label}
                        variant={variant}
                    />
                }
                disabled={disabled}
                loading={loading}
            />
            {/** </Grid>*/}
        </>
    )
}
InputFieldSelectSimple.propTypes = {
    id: PropTypes.string,
    label: PropTypes.node,
    open: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    getOptionLabel: PropTypes.func,
    options: PropTypes.array,
    loading: PropTypes.bool,
    renderOption: PropTypes.func,
    sm: PropTypes.number,
    md: PropTypes.number
}